export interface VideoState {
  isShowVideo: Ref<boolean>
  isPlaying: Ref<boolean>
  isShowVideoNav: Ref<boolean>
  isPause: Ref<boolean>
  isVideoArea: Ref<boolean>
}

export const VideoStateKey: InjectionKey<VideoState> = Symbol('VideoState')

export type TOOLTIP_Key = (typeof TOOLTIP_TYPE)[keyof typeof TOOLTIP_TYPE]
export interface TooltipItem {
  uuid: TOOLTIP_Key
  isOpen: boolean
}
export interface TooltipState {
  tooltipItems: Ref<Map<TOOLTIP_Key, TooltipItem>>
}

export const TOOLTIP_TYPE = {
  DELIVERY1: 'DELIVERY1',
  DELIVERY2: 'DELIVERY2',
  REVIEW1: 'REVIEW1',
  REVIEW2: 'REVIEW2',
  INFO1: 'INFO1',
  INFO2: 'INFO2'
} as const
export const TooltipStateKey: InjectionKey<TooltipState> = Symbol('TooltipState')
